import React from 'react';
import { resetPassword } from '../../networking/NetworkingUsers';
import AlertBox from '../shared/AlertBox';
import { shippingConfirmationValidation } from '../../networking/NetworkingOrders';
import { useEffect, useState } from "react";
import logo from '../../../src/img/logo_testtoken.png';

const  TestToken = ({token}) => {

    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [validate, setValidate] = useState(false);

    const onSendClick = async() => {
        console.log(token)
        
        const response = await shippingConfirmationValidation(token);

        if (response !== undefined) {
            if (Number(response.httpStatusCode) !== 200) {
                setAlertTitle('Error');
                setAlertMessage('An error ocurred while changing the password');
            } else {

                setAlertTitle('Success');
                setAlertMessage('Valid token');

            }
            setShowAlert(true);
        }             
    }

    useEffect(() => {
        callAPI();
    }, []);

    const callAPI = async() =>{
        console.log(token)        
        const response = await shippingConfirmationValidation(token);
        if (response !== undefined) {
            debugger;
            if (Number(response.httpStatusCode) !== 200) {
                setAlertTitle('Error');
                setAlertMessage('An error ocurred while changing the password');
            } else {
                setValidate(response.success);
            }
            setShowAlert(true);
        } 
    }

    const closeAlert = () =>{
        setShowAlert(false);
    }

    const styles = {
    page: {
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
    },

    returnText: {
        cursor: "pointer",
    },

    card: {
        width: "420px",
        margin: "60px auto",
        backgroundColor: "#fff",
        border: "1px solid #e5e5e5",
        padding: "30px 40px",
        textAlign: "center",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    },

    title: {
        margin: 0,
        marginBottom: "18px",
        fontSize: "26px",
        color: "#444",
        fontWeight: "bold",
    },

    message: {
        margin: 0,
        color: "#666",
        fontSize: "14px",
    },

    subMessage: {
        marginTop: "10px",
        color: "#999",
        fontSize: "13px",
    },

    bottomBar: {
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        height: "6px",
        backgroundColor: "#003b7a",
    },
    
    header: {
        height: "70px",
        backgroundColor: "#3f3f3f",
        position: "relative",
    },

    logo: {
        height: "52px",
        objectFit: "contain",
        display: "block",
    },
    
    logoWrapper: {
        position: "absolute",
        top: "4px",
        left: "300px",
        backgroundColor: "#fff",
        padding: "4px 8px",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    };

    return (
        <div style={styles.page}>
        <div style={styles.header}>
            <div style={styles.logoWrapper}>
                <img src={logo} alt="Logo" style={styles.logo}/>
            </div>                
        </div>        
        <div style={styles.card}>
            <h2 style={styles.title}>
                {validate
                    ? "Status updated"
                    : "Status already updated"}
            </h2>
            <p style={styles.message}>
            The status of your order has been successfully updated.
            </p>
            <p style={styles.subMessage}>
            Pleas, close this window.
            </p>
        </div>
        <div style={styles.bottomBar}></div>
        </div>
    );
}

export default TestToken